import React from "react";
import { motion } from "framer-motion";
import ResumeCard from "./ResumeCard";

const Experience = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.5 } }}
      className="py-12 font-titleFont flex flex-col lgl:flex-row gap-10 lgl:gap-20"
    >
      {/* Job Experience */}
      <div className="w-full lgl:w-1/2">
        <div className="flex flex-col gap-4">
          <p className="text-sm text-designColor tracking-[4px]">2016 - Present</p>
          <h2 className="text-4xl font-bold">Job Experience</h2>
        </div>

        <div className="mt-14 w-full h-auto border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10">
          <ResumeCard
            title="Senior QA Automation Engineer / SDET (Freelance)"
            subTitle="Freelance · 2024 - Present"
            result="Remote"
            des="Provided QA Automation/SDET services as a freelancer, designing and maintaining scalable automation frameworks for web and API testing. Integrated Playwright, Cypress, and REST validations into CI/CD pipelines, focused on improving test stability, increasing release confidence, and enabling earlier defect detection across cloud-based environments."
          />

          <ResumeCard
            title="QA Automation Engineer"
            subTitle="ADL Digital Lab · 2021 - 2023"
            result="Colombia"
            des="Implemented automation for critical user journeys and REST APIs using Selenium, Serenity BDD, and Postman. Contributed to faster feedback cycles, higher test coverage, and more reliable deployments through continuous integration."
          />

          <ResumeCard
            title="QA Automation Engineer"
            subTitle="Devco · 2021 - 2022"
            result="Mexico"
            des="Strengthened quality practices by building automated regression suites and API validations. Collaborated closely with developers and product teams to prevent defects, improve code quality, and accelerate delivery."
          />

          <ResumeCard
            title="Software Engineer"
            subTitle="Bancolombia · 2020 - 2021"
            result="Colombia"
            des="Supported quality initiatives for large-scale enterprise systems by defining test strategies, automating critical scenarios, and improving execution efficiency through structured reporting and automation frameworks."
          />

          <ResumeCard
            title="Test Automation Engineer"
            subTitle="Choucair Testing · 2017 - 2020"
            result="Colombia"
            des="Worked on functional and automated testing initiatives across multiple projects, applying best practices in test design, automation frameworks, and defect management to increase coverage and product stability."
          />

          <ResumeCard
            title="Systems Analyst"
            subTitle="Universidad de Caldas · 2014 - 2017"
            result="Colombia"
            des="Supported academic and administrative systems through requirements analysis, system support, and process improvements, gaining early experience in structured analysis and system-level problem solving."
          />
        </div>
      </div>

      {/* Trainer Experience */}
      <div className="w-full lgl:w-1/2">
        <div className="flex flex-col gap-4">
          <p className="text-sm text-designColor tracking-[4px]">2013 - Present</p>
          <h2 className="text-4xl font-bold">Trainer Experience</h2>
        </div>

        <div className="mt-14 w-full h-auto border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10">
          <ResumeCard
            title="Instructor"
            subTitle="Universidad Autónoma de Manizales · Oct 2024 - Present"
            result="Colombia"
            des="Designed and delivered the 'Automatización de Pruebas' course for the Software Engineering specialization, with a hands-on approach to test automation frameworks, best practices, and real-world QA scenarios."
          />

          <ResumeCard
            title="Academic Support & Training"
            subTitle="Universidad de Caldas · 2013 - 2016"
            result="Colombia"
            des="Trained faculty and students in the use of bibliographic resources and academic databases, designed Moodle-based courses, and administered bibliographic management systems, strengthening teaching and research workflows."
          />
        </div>
      </div>
    </motion.div>
  );
};

export default Experience;